const env = process.env.DEFINE_NODE_ENV;//dev：开发， test：测试，prod：生产
console.log('当前环境：', process.env, 'env:', env,)

let host = "", rbacHost = "", workOrderHost = '';
const country = window.location.pathname.replaceAll("/", "") || 'us'
switch (env) {
	case "prod":
		host = `https://prod-gss-api.popmart.com/${country}/customer-api`;
		rbacHost = `https://prod-gss-api.popmart.com/${country}/rbac-api`;
		workOrderHost = `https://prod-gss-api.popmart.com/${country}`;
		break;
	default:
		host = `https://beta-gss-api.popmart.com/${country}/customer-api`;
		rbacHost = `https://beta-gss-api.popmart.com/${country}/rbac-api`;
		workOrderHost = `https://beta-gss-api.popmart.com/${country}`;
		break;
}

export default {
	env,
	platform: 'web',
	baseHost: host,
	rbacHost,
	workOrderHost
}
